function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CSV_COLUMNS } from 'swag-common/constants/custom-store-shipouts.constants';
export function mapShipoutCsvRowToHeaderNames(line, header) {
  const headerMap = header.reduce((all, next) => _objectSpread({}, all, {
    [next.original]: next.title
  }), {});
  if (headerMap) {
    return Object.keys(line).reduce((row, field) => {
      const key = headerMap[field] ? headerMap[field] : field;
      return _objectSpread({}, row, {
        [key.toLowerCase()]: line[field]
      });
    }, {});
  }
  return line;
}
export function mapShipoutCsvRowToDBStructure(line, header) {
  const receiver = mapShipoutCsvRowToHeaderNames(line, header);
  return {
    _id: receiver._id,
    firstName: receiver[CSV_COLUMNS.FIRST_NAME.toLowerCase()],
    lastName: receiver[CSV_COLUMNS.LAST_NAME.toLowerCase()],
    address: receiver[CSV_COLUMNS.ADDRESS.toLowerCase()],
    country: receiver[CSV_COLUMNS.COUNTRY.toLowerCase()],
    state: receiver[CSV_COLUMNS.STATE.toLowerCase()],
    zip: receiver[CSV_COLUMNS.ZIP.toLowerCase()],
    unit: receiver[CSV_COLUMNS.UNIT.toLowerCase()],
    city: receiver[CSV_COLUMNS.CITY.toLowerCase()],
    phone: receiver[CSV_COLUMNS.PHONE.toLowerCase()],
    email: receiver[CSV_COLUMNS.EMAIL.toLowerCase()],
    isAddressEnteredManually: receiver.isAddressEnteredManually
  };
}